export default __webpack_public_path__ + "static/media/silhouette-girl1.9a1867db.svg";